export const mediaFields = {
    largeSize: [
        'prod.LARGE_IMAGE',
        'prod.IMAGE_L',
        'sku.LARGE_ALT_IMAGES',
        'sku.LARGE_IMAGE',
        'sku.IMAGE_L',
        'sku.IMAGE_ALT_L',
        'sku.IMAGE_L_V3'
    ],
    mediumSize: [
        'prod.IMAGE_M',
        'prod.MEDIUM_IMAGE',
        'sku.IMAGE_MEDIUM',
        'sku.IMAGE_M',
        'sku.IMAGE_ALT_M',
        'sku.IMAGE_M_V3',
        'sku.MEDIUM_IMAGE_V2'
    ],
    smallSize: [
        'prod.IMAGE_S',
        'prod.THUMBNAIL_IMAGE',
        'sku.SMALL_IMAGE',
        'sku.IMAGE_SMALL',
        'sku.IMAGE_S',
        'sku.IMAGE_ALT_S',
        'sku.THUMBNAIL_IMAGE'
    ]
};

export const skuFields = [
    'CART_ID',
    'IS_COLLECTION_DEFAULT_SKU',
    'COLLECTION_ID',
    'ITEM_QUANTITY',
    'UNIT_PRICE',
    'APPLIED_PRICE',
    'APPLIED_TAX',
    'DISCOUNT_AMOUNT',
    'DISCOUNT_PRICE',
    'DISCOUNT_PCT',
    'discountable',
    'formattedPrice',
    'formattedPriceRounded',
    'formattedUnitPrice',
    'isSampleItem',
    'isGiftItem',
    'isDonationItem',
    'isFreeVirtualSkuItem',
    'isLoyaltyReward',
    'isKitItem',
    'isWpOffer',
    'itemForm',
    'itemType',
    'formattedAppliedPrice',
    'category.CATEGORY_NAME',
    'prod.url',
    'prod.PRODUCT_ID',
    'prod.PROD_RGN_NAME',
    'prod.PROD_RGN_SUBHEADING',
    'prod.GIFTSET_COMPONENTS',
    'prod.SUB_LINE',
    'prod.SHORT_DESC',
    'prod.isHazmat',
    'prod.shaded',
    'prod.sized',
    'prod.PROD_BASE_NAME',
    'prod.FAMILY_CODE',
    'replenishmentItemForm',
    'sku.SKU_BASE_ID',
    'sku.SKU_ID',
    'sku.label',
    'sku.isRefillable',
    'sku.REFILLABLE',
    'sku.PRICE',
    'sku.PRICE2',
    'sku.formattedPrice',
    'sku.formattedPriceRounded',
    'sku.HEX_VALUE',
    'sku.HEX_VALUE_STRING',
    'sku.PRODUCT_SIZE',
    'sku.SHADENAME',
    'sku.isOutOfStock',
    'sku.isInactive',
    'sku.isSoldOut',
    'sku.swatchList',
    'sku.isDefaultCollectionSku',
    'sku.SUPPRESS_IN_CART',
    'maxAllowedQty',
    'discountPercent',
    'discountedAppliedPrice',
    'OFFER_CODE',
    'IS_ENGRAVABLE',
    'sku.IS_ENGRAVABLE',
    'offer.benefit.Bogo',
    'offer.benefit.FixedPrice',
    'offer.benefit.FlatDiscount',
    'offer.benefit.PercentDiscount',
    'offer.benefit.ProDiscount',
    'offer.benefit.FullSizeSkus',
    'offer.benefit.Skus',
    'offer.benefit.FullSizeChoiceOfSkus',
    'loyaltyRewardCostInPoints',
    ...mediaFields.largeSize,
    ...mediaFields.mediumSize,
    ...mediaFields.smallSize
];
